import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'

async function getCodeSet(authState: tsWhoAmI, CodeSetName: string) {
  return await phpClient(authState)
    .get<any>(`/json/framework/getCodeSet.php?CodeSetName=${CodeSetName}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getKVCodeSet(authState: tsWhoAmI, CodeSetName: string) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/generic/getKVCodeSet.php?CodeSetName=${CodeSetName}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const CodeSetService = {
  getKVCodeSet,
  getCodeSet,
}

export default CodeSetService
